import axios from "axios";
import React, { useState, useContext } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { Axios } from "./axios";

const API_URL = process.env.REACT_APP_API_URL;

class Service {
  async login(loginvalues) {
    try {
      const response = await Axios.post(API_URL + "session_login");
      console.log(response);
      return response;
    } catch (err) {
      console.log(err);
      console.log(err.response);
      return err.response;
    }
  }

  getCurrentUser() {
    const userDetails = JSON.parse(sessionStorage.getItem("userDetails"));
    console.log(userDetails);
    return userDetails;
  }

  //create request
  async createRequest(payload) {
    try {
      const response = await Axios.post(
        API_URL + "create_request_type",
        payload
      );
      console.log(response.status);
      return response;
    } catch (err) {
      console.log(err);

      console.log(err.response);
      return err.response.data;
    }
  }
  //get request types
  async getRequestTypes() {
    try {
      const response = await Axios.get(API_URL + "get_request_type");
      return response;
    } catch (err) {
      console.log(err);

      console.log(err.response);
      return err.response.data;
    }
  }

  //get request types
  async getValidationTypes() {
    try {
      const response = await Axios.get(API_URL + "fetch_validations");
      return response;
    } catch (err) {
      console.log(err);

      console.log(err.response);
      return err.response.data;
    }
  }

  //log requests
  async logRequest(payload) {
    try {
      const response = await Axios.post(API_URL + "log_request", payload);
      return response;
    } catch (err) {
      console.log(err);

      console.log(err.response);
      return err.response.data;
    }
  }

  //log bulk requests
  async logBulkRequest(payload) {
    try {
      const response = await Axios.post(API_URL + "import_request", payload);
      return response;
    } catch (err) {
      console.log(err.response);
      return err.response;
    }
  }

  //get logged requests
  async getLoggedRequests() {
    try {
      const response = await Axios.get(
        API_URL +
          `get_logged_request_staff_id?staff_id=${
            JSON.parse(sessionStorage.getItem("userDetails")).staff_id
          }`
      );
      return response;
    } catch (err) {
      console.log(err);

      console.log(err.response);
      return err.response.data;
    }
  }

  //Approve Request
  async approveRequest(payload) {
    try {
      const response = await Axios.post(API_URL + "approve_request", payload);
      return response;
    } catch (err) {
      console.log(err);

      console.log(err.response);
      return err.response.data;
    }
  }

  async createValidation(payload) {
    try {
      const response = await Axios.post(API_URL + 'add_validations', payload);
      console.log(response);
      return response;
    } catch (err) {
      console.log(err);
      console.log(err.response);
      return err.response;
    }
  }

  //Halt Request
  async haltRequest(payload) {
    try {
      const response = await Axios.post(API_URL + "halt_request", payload);
      return response;
    } catch (err) {
      console.log(err);

      console.log(err.response);
      return err.response.data;
    }
  }

  //Pend Request
  async pendRequest(payload) {
    try {
      const response = await Axios.post(API_URL + "pending_request", payload);
      return response;
    } catch (err) {
      console.log(err);

      console.log(err.response);
      return err.response.data;
    }
  }

  //Reject Request
  async rejectRequest(payload) {
    try {
      const response = await Axios.post(API_URL + "reject_request", payload);
      return response;
    } catch (err) {
      console.log(err);

      console.log(err.response);
      return err.response.data;
    }
  }

  //export request types
  async exportRequests(requestId) {
    window.open(`${API_URL}export_request?request_id=${requestId}`);
  }
  //export all request for approvals
  async getRequestsForApproval(requestId) {
    try {
      const userDetails = JSON.parse(sessionStorage.getItem("userDetails"));
      const staffId = userDetails.staff_id;

      const response = await fetch(
        `${API_URL}export_request_staff_id?staff_id=${staffId}&request_id=${requestId}`,
        {
          headers: {
            Authorization: "Bearer " + sessionStorage.getItem("SSOToken"),
          },
        }
      );

      if (!response.ok) {
        throw new Error(`Network response was not ok: ${response.statusText}`);
      }

      const blob = await response.blob();

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `file_${requestId}.csv`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Error:", error.message);
      // Handle error or show an error message to the user
    }
  }

  //create user
  async createUser(payload) {
    try {
      const response = await Axios.post(API_URL + "create_user", payload);
      console.log(response.status);
      return response;
    } catch (err) {
      console.log(err);

      console.log(err.response);
      return err.response.data;
    }
  }

  
  async updateTemplateValidation(payload) {
    try {
      const response = await Axios.post(API_URL + "update_template_validation", payload);
      console.log(response.status);
      return response;
    } catch (err) {
      console.log(err);

      console.log(err.response);
      return err.response.data;
    }
  }

  //bulk creation of users
  async bulkUsers(payload) {
    try {
      const response = await Axios.post(API_URL + "import_users", payload);

      return response;
    } catch (err) {
      console.log(err);

      console.log(err.response);
      return err.response.data;
    }
  }
  //map user
  async mapUser(payload) {
    try {
      const response = await Axios.post(
        API_URL + "create_user_mapping",
        payload
      );
      console.log(response.status);
      return response;
    } catch (err) {
      console.log(err);

      console.log(err.response);
      return err.response.data;
    }
  }

  //bulk mapping
  async bulkMapping(payload) {
    try {
      const response = await Axios.post(
        API_URL + "import_user_mapping",
        payload
      );
      return response;
    } catch (err) {
      console.log(err.response);
      return err.response;
    }
  }
}

export default new Service();
